import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container, Message, Icon, Accordion } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import { showAssignTagsModalFromOU } from 'actions/modal.js';
import { previousPage } from 'actions/navigationBar';
import { useDispatch } from 'react-redux';
import xss from 'xss';
import HtmlToReact from 'html-to-react';
// This component represents the whole right hand side panel on Desktop And represents the top panel above center panel on Mobile/Tablet
let htmlToReactParser = new HtmlToReact.Parser(React);

export default function RightPanelOrTopPanel(props) {
  const dispatch = useDispatch();
  const openAssignTagsModal = () => {
    dispatch(showAssignTagsModalFromOU(true));
  };

  const isOrgUnitLoaded = props.orgUnit && props.orgUnit.id > 0;

  const buttonsForDesktop =
    props.availableTags != null ? (
      props.availableTags.length > 0 ? (
        <div>
          <button
            type="button"
            className="ui labeled icon button mrbs color-button color-white right-hand-side-button"
            onClick={openAssignTagsModal}
          >
            <i className="tag icon" />
            {APP.LANGUAGE.WaitingAreaManageTags.AssignTagButtonText}
          </button>
        </div>
      ) : (
        <Message
          icon
          className="borderless bg-transparent pdlnull pdrnull"
          style={{ paddingTop: '11px', paddingBottom: '21px' }}
        >
          <Icon name="tags" className="mrrm" style={{ fontSize: '1.5em' }} />
          <Message.Content>
            <h4 className="no-bold">
              {htmlToReactParser.parse(xss(APP.LANGUAGE.WaitingAreaManageTags.NoAvailableTagMsg))}
            </h4>
          </Message.Content>
        </Message>
      )
    ) : (
      ''
    );

  const buttonsForTablet =
    props.availableTags != null ? (
      props.availableTags.length > 0 ? (
        <div>
          <button
            className="ui labeled icon button color-button color-white right-hand-side-button mrrsss mrbml"
            onClick={openAssignTagsModal}
          >
            <i className="tag icon" />
            {APP.LANGUAGE.WaitingAreaManageTags.AssignTagButtonText}
          </button>
        </div>
      ) : (
        <Message icon className="borderless bg-transparent pdlnull pdrnull pdtnull pdbnull">
          <Message.Content>
            <h4 className="no-bold">
              {htmlToReactParser.parse(xss(APP.LANGUAGE.WaitingAreaManageTags.NoAvailableTagMsg))}
            </h4>
          </Message.Content>
        </Message>
      )
    ) : (
      ''
    );

  const buttonsForMobile =
    props.availableTags != null ? (
      props.availableTags.length > 0 ? (
        <div>
          <button className="ui icon button color-button color-white mrrsss" onClick={openAssignTagsModal}>
            <i className="tag icon" />
          </button>
        </div>
      ) : (
        <Message icon className="borderless bg-transparent pdlnull pdrnull pdtnull pdbnull">
          <Message.Content>
            <h4 className="no-bold">
              {htmlToReactParser.parse(xss(APP.LANGUAGE.WaitingAreaManageTags.NoAvailableTagMsg))}
            </h4>
          </Message.Content>
        </Message>
      )
    ) : (
      ''
    );

  return (
    <div style={{ height: '100%' }}>
      <Container fluid as={Media} greaterThanOrEqual="computer" style={{ height: '100%' }}>
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdtxl pdbm pdrm logo-on-right-hand">
            <img className="ui image pdtxs umbrella-logo umbrella-logo-large" src={APP.IMAGES.UmbrellaLogo.default} />
            <img className="ui image  umbrella-logo umbrella-logo-small" src={APP.IMAGES.SmallUmbrellaLogo.default} />
          </div>
          <div className="pdll pdrm pdbs">{buttonsForDesktop}</div>
          <div className="pdbm pdrm pdlm">{props.bottomSession}</div>
        </div>
      </Container>
      <Container fluid as={Media} at="tablet">
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdlm pdrm">{buttonsForTablet}</div>
          {isOrgUnitLoaded && (
            <div className="mrtm mrbm">
              <Link
                className="back-to-wa-link color-organisational-unit left-text pdlm pdbs"
                to={'/organisational-unit/view-all'}
                style={{ width: '100%' }}
                onClick={() => {
                  dispatch(previousPage(APP.LANGUAGE.OrganisationalUnitManageTags.PageHeaderTitle));
                }}
              >
                <i className="chevron circle left icon" />
                <span>{APP.LANGUAGE.OrganisationalUnitManageTags.BackToOrgUnitsLinkText}</span>
              </Link>
            </div>
          )}
        </div>
      </Container>
      <Container fluid as={Media} at="mobile">
        <div className="right-top-waiting-area-view-one ui form mrtnull">
          <div className="pdbm pdlm pdrm">{buttonsForMobile}</div>
          {isOrgUnitLoaded && (
            <div className="mrbm">
              <Link
                className="back-to-wa-link color-organisational-unit left-text pdlm pdbs"
                to={'/organisational-unit/view-all'}
                style={{ width: '100%' }}
                onClick={() => {
                  dispatch(previousPage(APP.LANGUAGE.OrganisationalUnitManageTags.PageHeaderTitle));
                }}
              >
                <i className="chevron circle left icon" />
                <span>{APP.LANGUAGE.OrganisationalUnitManageTags.BackToOrgUnitsLinkText}</span>
              </Link>
            </div>
          )}
        </div>
      </Container>
    </div>
  );
}

RightPanelOrTopPanel.propTypes = {
  orgUnit: PropTypes.object.isRequired,
};
